import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import AuthPage from "./auth/AuthPage";
import ChallengeList from "./challenges/ChallengeList";
import ChallengePage from "./challenges/ChallengePage";

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  return (
    <header className="app-header">
      <a href="/" className="logo">
        <span className="brand-mark">𝍅</span> Frigatebird
      </a>
      {user && (
        <div className="header-right">
          <span className="muted">{user.username}</span>
          <button className="link-btn" onClick={logout}>Log out</button>
        </div>
      )}
    </header>
  );
};

const Protected: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="panel">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const Shell: React.FC = () => {
  const { user } = useAuth();
  return (
    <BrowserRouter>
      {user && <Header />}
      <main className="app-main">
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" replace /> : <AuthPage />} />
          <Route
            path="/"
            element={
              <Protected>
                <ChallengeList />
              </Protected>
            }
          />
          <Route
            path="/challenges/:id"
            element={
              <Protected>
                <ChallengePage />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
};

const App: React.FC = () => (
  <AuthProvider>
    <Shell />
  </AuthProvider>
);

export default App;
